import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import ConfirmPopup from './ConfirmPopup';

interface AllocateMultiTrucksSimpleProps {
    scheduleId: number;
    jobQuoteItemId: number;
    scheduleDate: string;
    truckOptions: TruckListOption[];
    showModal: boolean;
    hideModal(): void;
    save(): void;
}

interface TruckListOption {
    id: number;
    branchId: number;
    name: string;
    registrationNumber: string;
    scheduleVehicleId: number;
    teamDisplay: string;
    numberTeamMembers: number;
}

interface JobItemDetails {
    scheduleId: number;
    jobId: number;
    item: string;
    itemId: number;
    originalTruckId: number;
    originalTotal: number;
}

interface MultipleTrucks {
    scheduleId: number;
    truckId: number;
    quantityTotal: number;
    quantityScheduled: number;
    order: number;
    canEdit: boolean;
}

const AllocateMultiTruckSimpleModal = (props: AllocateMultiTrucksSimpleProps) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [jobItemDetails, setJobItemDetails] = React.useState<JobItemDetails>({
        scheduleId: 0,
        jobId: 0,
        itemId: 0,
        item: "", 
        originalTruckId: -1,
        originalTotal: 0
    });
    const [multipleTrucks, setMultipleTrucks] = React.useState<MultipleTrucks[]>([]);
    const [quantityToAllocate, setQuantityToAllocate] = React.useState(0);
    const [showConfirmModal, setShowConfirmModal] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);

    React.useEffect(() => {
        if (props.scheduleId > 0) {
            getData();
        }
    }, [props.scheduleId]);


    const getData = async () => {
        const token = await authService.getAccessToken();

        //get truck data
        axios.get("api/Allocate/GetMultipleTrucksSimple?ScheduledDate=" + props.scheduleDate + "&ScheduleId=" + props.scheduleId + "&JobQuoteItemId=" + props.jobQuoteItemId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var multipleTrucks = res.data.multipleTrucks;
            var totalQty = 0;
            //add the number of team members per truck
            for (var i = 0; i < multipleTrucks.length; i++) {
                totalQty += multipleTrucks[i].quantityScheduled;
            }
            var newBlankRow = addBlankRow();
            multipleTrucks.push(newBlankRow);

            setMultipleTrucks(multipleTrucks);
            setJobItemDetails(res.data.jobItemDetails);
            setQuantityToAllocate(totalQty);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const hideModal = () => {
        props.hideModal();
    }

    const onCellNumberChange = (e: any, index: number) => {
        var items = [...multipleTrucks];
        var item = items[index];
        var updatedItem: any = {};
        updatedItem = item;
        updatedItem[e.target.name] = e.target.value * 1;

        if (index == (items.length - 1)) {
            var newRow = addBlankRow();
            items.push(newRow);
        }

        setMultipleTrucks(items);
    }

    const deleteItem = (e: any, index: number) => {
        e.preventDefault();

        var items = [...multipleTrucks];
        var item = items[index];

        if (item.scheduleId > 0) {
            setShowConfirmModal(true);
            setDeleteIndex(index);
        } else {
            //just remove
            items.splice(index, 1);
            var openItems = items.filter(i => i.canEdit);
            if (openItems.length > 0) {
                openItems[0].quantityScheduled += item.quantityScheduled;  //add the qty we deleted back to original
            }
            setMultipleTrucks(items);
        }
    }

    const hideConfirmModal = () => {
        setShowConfirmModal(false);
        setDeleteIndex(-1);
    }

    const saveConfirmModal = () => {
        saveDeleteMultiple();
    }

    const saveDeleteMultiple = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var items = [...multipleTrucks];
        let multipleTruck = items[deleteIndex];
        var deleteItem = {
            scheduleId: multipleTruck.scheduleId,
            jobId: jobItemDetails.jobId,
            itemId: jobItemDetails.itemId,
            item: jobItemDetails.item,
            subId: user.sub
        };

        axios.post('api/Allocate/DeleteMultipleTruckAllocation', deleteItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            items.splice(deleteIndex, 1);
            var openItems = items.filter(i => i.canEdit);
            if (openItems.length > 0) {
                openItems[0].quantityScheduled += multipleTruck.quantityScheduled;  //add the qty we deleted back to original
            }
            setMultipleTrucks(items);
            setShowConfirmModal(false);
            setDeleteIndex(-1);
            toast.success("Item removed successfully");
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const addBlankRow = () => {
        var newRow: MultipleTrucks = {
            scheduleId: 0,
            truckId: -1,
            quantityTotal: jobItemDetails.originalTotal,
            quantityScheduled: 0,
            order: 0,
            canEdit: true
        };

        return newRow;
    }

    const validate = () => {
        var formIsValid = true;
        let errorList: any = {};

        var errorString = "Please enter the following values: ";
        var error = false;
        var rowNumber = 0;
        var totalQty = 0

        for (var i = 0; i < multipleTrucks.length - 1; i++) {
            rowNumber += 1;
            var item = multipleTrucks[i];
            var newErrorString = "";
            totalQty += item.quantityScheduled;

            if (item.truckId < 1) {
                newErrorString += " Valid Truck, ";
                error = true;
            }

            if (item.quantityScheduled < 1) {
                newErrorString += " Quantity > 0, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n";
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }
        }

        if (totalQty != quantityToAllocate) {
            error = true;
            errorString += "\n";
            errorString += "Quantity MUST total to " + quantityToAllocate;
        }

        if (error) {
            formIsValid = false;
            errorList["truckAllocation"] = errorString;
        }
        setErrors(errorList);

        return formIsValid;
    }

    const save = () => {
        if (validate()) {
            saveMultiTrucks();
        } else {
            toast.error("Please fix errors on screen before saving!");
        }
    }

    const saveMultiTrucks = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        multipleTrucks.pop();

        let multipleTruckSave = {
            id: props.scheduleId,
            multipleTrucks: multipleTrucks,
            subId: user.sub
        };

        axios.post('api/Allocate/SaveMultipleTruckAllocation', multipleTruckSave, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Item Saved Successfully");
            resetPopup();

            props.save();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const resetPopup = () => {
        var resetDetails: JobItemDetails = {
            scheduleId: 0,
            jobId: 0,
            itemId: 0,
            item: "",
            originalTruckId: -1,
            originalTotal: 0
        };

        setJobItemDetails(resetDetails);
        setMultipleTrucks([]);
        setShowConfirmModal(false);
        setDeleteIndex(-1);
        setErrors({});
    }

    const confirmPopup = <ConfirmPopup heading="Delete Truck Allocation?" text="Are you sure you want to delete this truck allocation?" hideConfirmModal={hideConfirmModal} showConfirmModal={showConfirmModal} saveConfirmModal={saveConfirmModal} />

    const renderDetails = (
        <div>
            {confirmPopup}

            <Modal show={props.showModal} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Allocate Truck for {jobItemDetails.item}</Modal.Title>
                    <button type="button" className="close" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <span>Note: Original Qty Total is the total quantity for the entire job</span>
                    <div>Note 2: Total Avail to Allocate is how much you can allocate for the current date. If some of the quantity is allocated to another day, you will need to delete that allocation in order to allocate the full quantity.</div>
                    <label className="input-group" htmlFor="originalTotal">
                        <span className="label">Original Qty Total</span>
                        <input type='number' id="originalTotal" name="originalTotal" className='input' value={jobItemDetails.originalTotal} disabled></input>
                    </label>

                    <label className="input-group" htmlFor="quantityToAllocate">
                        <span className="label">Total Avail To Allocate</span>
                        <input type='number' id="quantityToAllocate" name="quantityToAllocate" className='input' value={quantityToAllocate} disabled></input>
                    </label>

                    <div className="table__margin overflowAuto">
                        <table className="table table__small tableColours">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Truck</th>
                                    <th>Quantity</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {multipleTrucks.map((item, index) =>
                                    <tr key={index}>
                                        <td className="table__text--align">{index + 1}</td>
                                        <td className="table__text--align">
                                            <select className="select" id="truckId" name="truckId" value={item.truckId} onChange={(e) => onCellNumberChange(e, index)} disabled={item.truckId == jobItemDetails.originalTruckId || !item.canEdit} >
                                                <option defaultValue="-1"></option>
                                                {props.truckOptions.map(truck =>
                                                    <option key={truck.id} value={truck.id}>{truck.name}-{truck.registrationNumber}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className="table__text--align  table--cell--nowrap">
                                            <input type='number' min={0} step={1} id="quantityScheduled" name="quantityScheduled" className='input allocate__qtySize' value={item.quantityScheduled} onChange={(e) => onCellNumberChange(e, index)} disabled={!item.canEdit }></input>
                                        </td>
                                        <td className="table__text--align">
                                            <div className={item.truckId === jobItemDetails.originalTruckId || index == (multipleTrucks.length - 1) || !item.canEdit ? "hidden" : "delete--tablecell"}>
                                                <a className="makeitred" href="#" onClick={(e) => deleteItem(e, index)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                </a>
                                            </div>
                                        </td>

                                    </tr>

                                )}
                            </tbody>
                        </table>
                        {errors["truckAllocation"] ?
                            (errors["truckAllocation"]).split("\n").map((item: any, key: any) => {
                                return <span className="label errors" key={key}>{item}<br /></span>
                            })
                            : ""}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button className="popup-button--yes" onClick={save}>Save</button>
                </Modal.Footer>
            </Modal>
        </div>
    
    
    );


    let contents =
        props.scheduleId < 1 ? <div></div> :
        loading ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

}

export default AllocateMultiTruckSimpleModal;